// import $ from 'jquery';
import 'floatthead';

/** Bulk selection state (#check-all) — formerly implicit globals; ES modules require a declaration. */
let checkState = '';
let oldEntity = '';

function setNativeCheckbox(input, checked, emit = false)
{
    if (typeof window.setNativeChecked === 'function') {
        window.setNativeChecked(input, checked, emit);
        return;
    }

    input.checked = checked;
    if (emit) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

function setBulkRowSelected(input, selected)
{
    $(input).closest('tr').toggleClass('selected', selected);
}

/** Parse #dictionary JSON (handles accidental double-encoding). */
function getNaisDictionary()
{
    const el = document.getElementById('dictionary');
    if (!el) {
        return {};
    }
    let parsed = JSON.parse(el.textContent || el.innerHTML || '{}');
    if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
    }
    return parsed && typeof parsed === 'object' ? parsed : {};
}

/** Column count in the header row (checkbox + data + actions), not just .column-title. */
export function getDatagridHeadColspan(table)
{
    const $table = $(table);
    const headingCount = $table.find('thead tr.headings > th').length;
    if (headingCount > 0) {
        return headingCount;
    }
    let colCount = $table.find('thead .column-title').length;
    if ($table.find('thead th.grid-col-check, thead #check-all').length) {
        colCount += 1;
    }
    if ($table.find('thead #multiselect-all').length && !$table.find('thead #check-all').length) {
        colCount += 1;
    }
    if ($table.find('thead th.row-actions-head').length) {
        colCount += 1;
    }
    return colCount > 0 ? colCount : 1;
}

export function countChecked(table)
{
    const checkAllBtnExists = table.find('input#check-all');
    let itemName = `bulkActionIds${window.location.pathname}`;
    if (window.location.href.indexOf('multipleSelect') > 0) {
        itemName = window.location.href;
    }

    if (checkState === 'all') {
        table.find('.bulk-check input').each(function bulkCheckAll() {
            setNativeCheckbox(this, true, false);
            setBulkRowSelected(this, true);
        });
    }
    if (checkState === 'none') {
        table.find('.bulk-check input').each(function bulkCheckNone() {
            setNativeCheckbox(this, false, false);
            setBulkRowSelected(this, false);
        });
    }

    const saveItem = localStorage.getItem(itemName);
    let values = [];

    if (saveItem !== null) {
        values = JSON.parse(`[${saveItem}]`);
    }

    let entity = table.parent().parent().parent();
    if (oldEntity !== '' && entity.attr('id') !== oldEntity.attr('id')) {
        oldEntity.find('input#check-all').each(function oldEntityCheckAll() { setNativeCheckbox(this, false, false); });
        oldEntity.find('.bulk-check input').each(function oldEntityBulkCheck() {
            setNativeCheckbox(this, false, false);
            setBulkRowSelected(this, false);
        });
        values = [];
    }

    $(table).find('.bulk-check input').each(function bulkActionEach(e) {
        let index;
        let value;
        if ($(this).attr('id') !== undefined) {
            value = parseInt($(this).attr('id'));
            index = values.indexOf(value);
        } else if ($(this).attr('entityid') !== undefined) {
            value = parseInt($(this).attr('entityid'));
            index = values.indexOf(value);
        }
        if (this.checked === true) {
            if (index === -1) {
                values.push(value);
            }
        } else if (index !== -1) {
            values.splice(index, 1);
        }
    });
    localStorage.setItem(itemName, values);

    const checkCount = values.length;
    const colCount = getDatagridHeadColspan(table);

    let form = checkAllBtnExists.closest('form')[0];
    if (checkCount) {
        $(form).find('.defaultExportIcons').hide();
        $(form).find('.bulk-actions').attr('colspan', colCount).show();
        $(form).find('.bulk-actions-after').show();
        $(form).find('.action-cnt').html(checkCount);
    } else {
        $(form).find('.defaultExportIcons').show();
        $(form).find('.bulk-actions').hide();
        $(form).find('.bulk-actions-after').hide();
    }
    oldEntity = entity;
}

export function initCheckboxesBulkActions()
{
    const checkAllBtnExists = $('.bulk_action input#check-all');
    let values = [];
    let itemName = `bulkActionIds${window.location.pathname}`;
    if (window.location.href.indexOf('multipleSelect') > 0) {
        itemName = window.location.href;
    }
    if (checkAllBtnExists.length === 1) {
        if (localStorage.getItem('selectEntitiesOpen') === '1') {
            localStorage.setItem('selectEntitiesOpen', 0);
            const selections = JSON.parse(localStorage.getItem(`currentSelections${top.location.pathname}`));
            const ids = [];
            for (const property in selections) {
                ids.push(property);
            }
            localStorage.setItem(itemName, ids);
        } else {
            localStorage.setItem(`currentSelections${top.location.pathname}`, JSON.stringify({}));
        }
        const saveItem = localStorage.getItem(itemName);
        if (saveItem !== null) {
            values = JSON.parse(`[${saveItem}]`);
        }
    } else {
        localStorage.setItem(itemName, []);
    }

    if (typeof window.initNativeChecks === 'function') {
        window.initNativeChecks();
    }

    if (checkAllBtnExists.length === 1) {
        for (let i = 0; i < values.length; i++) {
            $(`.checkboxRows#${values[i]}`).each(function checkboxRowsEach() {
                setNativeCheckbox(this, true, false);
                setBulkRowSelected(this, true);
            });
        }

        const checkCount = values.length;
        const table = checkAllBtnExists.closest('table');
        const colCount = getDatagridHeadColspan(table);

        let form = checkAllBtnExists.closest('form')[0];
        if (checkCount) {
            $(form).find('.defaultExportIcons').hide();
            $(form).find('.bulk-actions').attr('colspan', colCount).show();
            $(form).find('.bulk-actions-after').show();
            $(form).find('.action-cnt').html(checkCount);
        } else {
            $(form).find('.defaultExportIcons').show();
            $(form).find('.bulk-actions').hide();
            $(form).find('.bulk-actions-after').hide();
        }
        initCheckboxesHandlers();
    }
}
window.initCheckboxesBulkActions = initCheckboxesBulkActions;

export function resetCheckboxesBulkActions()
{
    let itemName = `bulkActionIds${window.location.pathname}`;
    if (window.location.href.indexOf('multipleSelect') > 0) {
        itemName = window.location.href;
    }

    localStorage.setItem(itemName, []);
    const selections = JSON.parse(localStorage.getItem(`currentSelections${top.location.pathname}`));
    if (Object.keys(selections).length !== 0) {
        localStorage.setItem(localStorage.getItem('selectEntitiesName'), JSON.stringify({}));
        for (const property in selections) {
            parent.removeSelectedEntity(property);
        }
        localStorage.setItem(`currentSelections${top.location.pathname}`, JSON.stringify({}));
    }
    $("input[type='checkbox']").not('.leaflet-control-layers-selector').each(function resetCheckboxEach() {
        setNativeCheckbox(this, false, false);
        setBulkRowSelected(this, false);
    });
    initCheckboxesBulkActions();
}
window.resetCheckboxesBulkActions = resetCheckboxesBulkActions;

export function initCheckboxesHandlers()
{
    const checkAllBtnExists = $('.bulk_action input#check-all');

    // Table without bulk_action
    if (checkAllBtnExists.length !== 0) {
        $('table .bulk-check input')
            .off('change.naisBulkRow')
            .on('change.naisBulkRow', function tableInputChange() {
                let table = $(this).closest('table');
                checkState = '';
                setBulkRowSelected(this, this.checked);
                countChecked(table);
            });
        $('.bulk_action input')
            .off('change.naisBulkAction')
            .on('change.naisBulkAction', function bulkActionChange() {
                let table = $(this).closest('table');
                checkState = this.id === 'check-all'
                    ? (this.checked ? 'all' : 'none')
                    : '';
                setBulkRowSelected(this, this.checked);
                countChecked(table);
            });
    }
}
window.initCheckboxesHandlers = initCheckboxesHandlers;

export function exportSelectedRows(elem, paramPrefix)
{
    let itemName = `bulkActionIds${window.location.pathname}`;
    if (window.location.href.indexOf('multipleSelect') > 0) {
        itemName = window.location.href;
    }
    const saveItem = localStorage.getItem(itemName);
    let values = [];
    if (saveItem !== null) {
        values = JSON.parse(`[${saveItem}]`);
    }
    const allowedIds = {};
    allowedIds[`${paramPrefix}allowedIds`] = values;

    let split = elem.href.split(`&${paramPrefix}allowedIds`);
    elem.href = split[0] + `&${$.param(allowedIds)}`;
    return true;
}
window.exportSelectedRows = exportSelectedRows;

function calendarLang() {
    const raw = ($('html').attr('lang') || 'en').toLowerCase();
    return raw.split(/[_-]/)[0];
}

function markNaisDatepicker(_input, inst) {
    if (inst && inst.dpDiv) {
        inst.dpDiv.addClass('nais-datepicker');
    }
}

/**
 * timepicker-addon overrides _gotoToday for "Now", but on date-only pickers it only
 * navigates the calendar. Select today into the input (same quick-pick UX as "Nyní").
 */
function patchDatepickerGotoToday() {
    if (!$?.datepicker || $.datepicker._naisGotoTodayPatched) {
        return;
    }

    const gotoTodayWithTime = $.datepicker._gotoToday;
    $.datepicker._gotoToday = function naisGotoToday(id) {
        const inst = this._getInst($(id)[0]);
        if (this._get(inst, 'timepicker')) {
            gotoTodayWithTime.call(this, id);
            return;
        }

        this._setDate(inst, new Date());
        this._selectDate(id);
    };
    $.datepicker._naisGotoTodayPatched = true;
}

const calendarCommon = {
    showOtherMonths: true,
    selectOtherMonths: true,
    showWeek: true,
    firstDay: 1,
    changeMonth: true,
    changeYear: true,
    showButtonPanel: true, // Today / Done (datetimepicker already shows Now via timepicker addon)
    beforeShow: markNaisDatepicker,
};

export function initCalendars()
{
    const lang = calendarLang();
    if ($.datepicker.regional[lang]) {
        $.datepicker.setDefaults($.datepicker.regional[lang]);
    }
    if ($.timepicker.regional[lang]) {
        $.timepicker.setDefaults($.timepicker.regional[lang]);
    }
    patchDatepickerGotoToday();

    // CSS class drives mode: .datepicker (date) / .timepicker (time) / .datetimepicker (date+time)
    $('.datepicker:not(.entityItemsTable tr.hidden input.datepicker, [readonly])').each(function datepickerEach() {
        if ($(this).hasClass('hasDatepicker')) {
            return;
        }

        $(this).datepicker({
            ...calendarCommon,
            dateFormat: $(this).attr('jsdateformat')
        });

        if ($(this).attr('minDate')) {
            $(this).datepicker('option', 'minDate', new Date($(this).attr('minDate') * 1000));
        }

        if ($(this).attr('maxDate')) {
            $(this).datepicker('option', 'maxDate', new Date($(this).attr('maxDate') * 1000));
        }
    });

    $('.timepicker:not(.entityItemsTable tr.hidden input.datepicker, [readonly])').each(function timepickerEach() {
        if ($(this).hasClass('hasDatepicker')) {
            return;
        }

        $(this).timepicker({
            timeInput: true,
            timeFormat: $(this).attr('jstimeformat'),
            beforeShow: markNaisDatepicker,
        });
    });

    $('.datetimepicker:not(.entityItemsTable tr.hidden input.datepicker, [readonly])').each(function datetimepickerEach() {
        if ($(this).hasClass('hasDatepicker')) {
            return;
        }

        $(this).datetimepicker({
            ...calendarCommon,
            showDay: false,
            timeInput: true,
            dateFormat: $(this).attr('jsdateformat'),
            timeFormat: $(this).attr('jstimeformat')
        });

        if ($(this).attr('minDate')) {
            $(this).datepicker('option', 'minDate', new Date($(this).attr('minDate') * 1000));
        }

        if ($(this).attr('maxDate')) {
            $(this).datepicker('option', 'maxDate', new Date($(this).attr('maxDate') * 1000));
        }
    });

    $(".dateRangePicker:not(.entityItemsTable tr.hidden input.datepicker, [readonly]):not(.dateRangePickerInitialized)").each(
        function () {
            $(this).datepicker({
                ...calendarCommon,
                dateFormat: $(this).attr('dateformat'),
            }).addClass('dateRangePickerInitialized');
            // from/to min/max + clamp: initRangeLinks() via [data-nais-range]
       }
    );
}
window.initCalendars = initCalendars;

export function initTooltips(root = document) {
    if (typeof window.initBootstrapTooltips === 'function') {
        window.initBootstrapTooltips(root);
    }
}
window.initTooltips = initTooltips;

export function initSelect2Class() {
    $(document).ready(function documentReady() {
        $(document).find('select').each(function selectEach() {
            const $select = $(this);
            const $feedback = $select.closest('.has-feedback');
            if (!$feedback.length) {
                return;
            }

            $feedback.find('.select2-selection__rendered').each(function selectionrenderedEach() {
                const $rendered = $(this);
                if ($select.hasClass('has-feedback-left')) {
                    $rendered.addClass('iconPaddingLeft');
                } else if ($select.hasClass('has-feedback-right')) {
                    $rendered.addClass('iconPaddingRight');
                }
            });
        });
    });
}
window.initSelect2Class = initSelect2Class;

export function initMultiSortable() {
    $(document).ready(function documentReady() {
        $('ul.sortable').multisortable();
        $('ul#availableOrders').sortable('option', 'connectWith', 'ul#selectedOrders');
        $('ul#selectedOrders').sortable('option', 'connectWith', 'ul#availableOrders');
    });
}
window.initMultiSortable = initMultiSortable;

function showEntity(link, width, height, scrolling)
{
    $.fancybox.open({
        toolbar: false,
        autoSize: false,
        src: link,
        type: 'iframe',
        iframe: {
            preload: true,
            css: {
                width: `${width}px`,
                height: `${height}px`,
            },
            attr: {
                scrolling,
            },
        },
        scrolling: 'no',
        keys: {
            close: [27],
        },
    });
}
window.showEntity = showEntity;

function showHelp(link)
{
    $.fancybox.open({
        toolbar: false,
        autoSize: false,
        src: link,
        type: 'iframe',
        iframe: {
            preload: true,
            css: {
                width: '100%',
                height: '100%',
            }
        },
        baseClass: 'fancyHelp',
        scrolling: 'no',
        keys: {
            close: [27],
        },
    });
}
window.showHelp = showHelp;

function showEntities(el, name, filter)
{
    if (filter === undefined) {
        filter = null;
    }
    const $input = $(el).closest('div.input-group').find('input[type=text]').first();

    entitiesForm = $(el).closest('form').attr('id');
    entitiesInput = $input.attr('id');
    entitiesName = name;
    let value = $input.val() || '';
    let link = `${$(el).attr('href')}&entitiesSelect=1&entitiesName=${encodeURIComponent(name)}`
        + `&inputValueToFill=${encodeURIComponent(value)}`;

    if (filter) {
        link += filter;
    }

    $.fancybox.open({
        src: link,
        type: 'iframe',
        width: '80%',
        modal: false,
        keys: {
            close: [27],
        },
    });
}
window.showEntities = showEntities;

function showEntitiesFilter(el, name)
{
    entitiesForm = $(el).closest('form').attr('id');
    entitiesInput = $(el).closest('div.input-group').find('input[type=text]').attr('id');
    entitiesName = name;
    const link = `${$(el).attr('href')}&entitiesSelect=1&entitiesName=${encodeURIComponent(name)}`;
    $.fancybox.open({
        src: link,
        type: 'iframe',
        width: '80%',
        modal: false,
        keys: {
            close: [27],
        },
    });
}
window.showEntitiesFilter = showEntitiesFilter;

let entitiesForm = null;
let entitiesName = null;
let entitiesInput = null;
export let activeMultipleSelect = null;
window.activeMultipleSelect = activeMultipleSelect;

function showMultipleEntities(el, name)
{
    entitiesName = name;

    if (window.activeMultipleSelect == null) {
        localStorage.setItem(`currentSelections${top.location.pathname}`, JSON.stringify({}));
        localStorage.setItem(name, JSON.stringify({}));
    }
    window.activeMultipleSelect = name;

    localStorage.setItem(
        `currentSelections${top.location.pathname}`,
        localStorage.getItem(window.activeMultipleSelect) || JSON.stringify({}),
    );
    localStorage.setItem('selectEntitiesOpen', 1);
    localStorage.setItem('selectEntitiesName', window.activeMultipleSelect);
    const link = `${$(el).attr('href')}&multipleSelect=1`;
    $.fancybox.open({
        src: link,
        type: 'iframe',
        toolbar: false,
        modal: false,
        baseClass: 'fancyEntitiesSelect',
        iframe: {
            preload: true,
            css: {
                width: '100%',
                height: '100%',
            },
        },
        keys: {
            close: [27],
        },
        afterClose() {
            localStorage.setItem('selectEntitiesOpen', 0);
            localStorage.setItem('selectEntitiesName', JSON.stringify({}));
        },
    });
}
window.showMultipleEntities = showMultipleEntities;

function displayChosenEntity(id, name, additionalInfo, parentName)
{
    if (String(id) === '' || String(name) === '') {
        return;
    }

    const pickerName = String(parentName || entitiesName || '');
    let $input = $(`form#${entitiesForm} input#${entitiesInput}`).first();

    if (!$input.length && pickerName !== '') {
        $input = $('input:text.entitiesForm').filter(function entityPickerByParent() {
            return $(this).attr('parent') === pickerName;
        }).first();
    }

    if (!$input.length) {
        return;
    }

    const actualParentName = pickerName || $input.attr('parent') || '';

    upsertEntityPickerSourceItem($input, id, name, actualParentName);
    setEntityPickerValue($input, {
        id: String(id),
        label: String(name),
        value: String(name),
        parent: String(actualParentName),
    });

    if (additionalInfo != null) {
        $(`#${additionalInfo[0]}`).attr('value', additionalInfo[1]);
    }
}
window.displayChosenEntity = displayChosenEntity;

function chooseEntity(id, name, additionalInfo)
{
    if (String(id) === '' || String(name) === '') {
        return;
    }

    const parentName = new URLSearchParams(window.location.search).get('entitiesName');

    if (typeof parent.displayChosenEntity === 'function') {
        parent.displayChosenEntity(id, name, additionalInfo, parentName);
    }

    if (parent.jQuery?.fancybox) {
        parent.jQuery.fancybox.close();
    }
}
window.chooseEntity = chooseEntity;

export function handleEntityPickerChoiceResponse()
{
    const choice = document.querySelector('[data-nais-entity-picker-choice]');
    if (!choice || window.parent === window) {
        return false;
    }

    const id = choice.getAttribute('data-entity-id') || '';
    const name = choice.getAttribute('data-entity-name') || '';
    const parentName = choice.getAttribute('data-parent-name') || '';
    const multiple = choice.getAttribute('data-multiple-select') === '1';

    if (id === '' || name === '') {
        return true;
    }

    if (multiple && typeof window.parent.saveSelectedEntity === 'function') {
        window.parent.saveSelectedEntity(id, name);
    } else if (typeof window.parent.displayChosenEntity === 'function') {
        window.parent.displayChosenEntity(id, name, null, parentName);
    }

    if (window.parent.jQuery?.fancybox) {
        window.parent.jQuery.fancybox.close();
    }

    return true;
}
window.handleEntityPickerChoiceResponse = handleEntityPickerChoiceResponse;

function bindEntityPickerChoiceButtons()
{
    $(document)
        .off('click.naisEntityPickerChoice', '[data-nais-entity-choice]')
        .on('click.naisEntityPickerChoice', '[data-nais-entity-choice]', function onEntityPickerChoice(event) {
            event.preventDefault();

            const $choice = $(this);
            const id = $choice.attr('data-entity-id') || '';
            const name = $choice.attr('data-entity-name') || '';
            const additionalTarget = $choice.attr('data-additional-target') || '';
            const additionalValue = $choice.attr('data-additional-value') || '';
            const additionalInfo = additionalTarget !== '' ? [additionalTarget, additionalValue] : null;

            if (id === '' || name === '') {
                return;
            }

            chooseEntity(id, name, additionalInfo);
        });
}
window.bindEntityPickerChoiceButtons = bindEntityPickerChoiceButtons;

function bindEntitiesPickerButtons()
{
    $(document)
        .off(
            'click.naisEntitiesPicker',
            '[data-nais-entities-trigger], [data-nais-entities-list-trigger], [data-nais-disabled-message]'
        )
        .on(
            'click.naisEntitiesPicker',
            '[data-nais-entities-trigger], [data-nais-entities-list-trigger], [data-nais-disabled-message]',
            function onEntitiesPickerButton(event) {
                event.preventDefault();

                const $button = $(this);
                const disabledMessage = $button.attr('data-nais-disabled-message') || '';
                if ($button.hasClass('disabled') || $button.is(':disabled')) {
                    if (disabledMessage !== '') {
                        alert(disabledMessage);
                    }
                    return;
                }

                const listName = $button.attr('data-nais-entities-list-name') || '';
                if ($button.is('[data-nais-entities-list-trigger]') && listName !== '') {
                    showMultipleEntities(this, listName);
                    return;
                }

                const name = $button.attr('data-nais-entities-name') || '';
                if (name === '') {
                    return;
                }

                const filter = $button.attr('data-nais-entities-filter') || '';
                if (filter !== '') {
                    showEntities(this, name, filter);
                    return;
                }

                showEntitiesFilter(this, name);
            }
        );
}
window.bindEntitiesPickerButtons = bindEntitiesPickerButtons;

export function saveSelectedEntity(id, name)
{
    const dictionary = getNaisDictionary();
    const listName = window.activeMultipleSelect;
    if (!listName || String(id) === '' || String(name) === '') {
        return;
    }

    const removeLabel = dictionary.remove || 'Remove';
    const safeName = $('<div>').text(String(name)).html();
    const deleteButton = '<button type="button"'
        + ' class="btn-close"'
        + ` title="${removeLabel}" aria-label="${removeLabel}"`
        + ` id="delete-entity-${listName}-${id}"`
        + ` data-id="${id}" data-entity-list="${listName}"></button>`;

    const entitiesList = JSON.parse(localStorage.getItem(listName) || '{}');
    const alreadySelected = Object.prototype.hasOwnProperty.call(entitiesList, id);
    entitiesList[id] = name;
    $(`#${listName}JSON`).val(JSON.stringify(entitiesList));
    const $table = getEntitiesListTable(listName);
    if (!alreadySelected) {
        $table.DataTable().row.add([
            id,
            `<div class="d-flex align-items-center justify-content-between gap-2">`
                + `<span>${safeName}</span>${deleteButton}`
                + `</div>`,
        ]);
        $table.DataTable().draw();
    }
    localStorage.setItem(listName, JSON.stringify(entitiesList));
    localStorage.setItem(
        `currentSelections${top.location.pathname}`,
        localStorage.getItem(listName),
    );
    $(`form:not(.ays-ignore) #${listName}JSON`).trigger('checkform.areYouSure');
    $(`#delete-entity-${listName}-${id}`).off('click.naisEntities').on('click.naisEntities', (event) => {
        event.preventDefault();
        window.activeMultipleSelect = $(event.currentTarget).attr('data-entity-list');
        removeSelectedEntity($(event.currentTarget).attr('data-id'));
    });
}
window.saveSelectedEntity = saveSelectedEntity;

function getEntitiesListTable(listName)
{
    const byData = $(`table.entitiesListTable[data-list-name="${listName}"]`);
    if (byData.length) {
        return byData.first();
    }
    return $(`#${listName}Table, #${listName}`).filter('table').first();
}
window.getEntitiesListTable = getEntitiesListTable;

export function showOnlySelectedMultipleEntities(element, multipleSelectName)
{
    const entitiesList = JSON.parse(localStorage.getItem(multipleSelectName) || '{}');
    let ajaxLink = $(element).data('ajax-link');
    $.nette.ajax({
        type: 'get',
        url: ajaxLink,
        data: {
            showIds: Object.keys(entitiesList),
            btnActive: $(element).data('active')
        }
    });
}
window.showOnlySelectedMultipleEntities = showOnlySelectedMultipleEntities;

export function removeSelectedEntity(id)
{
    const listName = window.activeMultipleSelect;
    const entitiesList = JSON.parse(localStorage.getItem(listName) || '{}');
    delete entitiesList[id];
    const $table = getEntitiesListTable(listName);
    $table.DataTable()
        .row($table.find('td').filter(function filterActiveMultple() {
            return $(this).text() === id;
        }).closest('tr')).remove();

    $table.DataTable().draw();
    $(`#${listName}JSON`).val(JSON.stringify(entitiesList));
    localStorage.setItem(listName, JSON.stringify(entitiesList));
    localStorage.setItem(
        `currentSelections${top.location.pathname}`,
        localStorage.getItem(listName),
    );
    $(`form:not(.ays-ignore) #${listName}JSON`).trigger('checkform.areYouSure');
}
window.removeSelectedEntity = removeSelectedEntity;

/**
 * Add required asterisk to manually rendered Latte labels (e.g. Settings)
 * whose wrappers have `.required` but no FormRenderer `requiredsuffix`.
 * Skip labels that already have the marker so FormRenderer / AJAX re-init
 * do not produce " * *".
 */
export function updateRequiredLabels()
{
    $('.required label').each(function updateRequiredLabelEach() {
        const $label = $(this);
        if ($label.children('span.required').length > 0) {
            return;
        }
        $label.append('<span class="required"> *</span>');
    });
}
window.updateRequiredLabels = updateRequiredLabels;

export function startTime()
{
    const today = new Date();
    const h = today.getHours();
    let m = today.getMinutes();
    let s = today.getSeconds();
    m = checkTime(m);
    s = checkTime(s);
    $('#actualTime').html(`${h}:${m}:${s}`);
    $('#topTime').html(`${h}:${m}`);
    const t = setTimeout(startTime, 500);
}
window.startTime = startTime;

function checkTime(i)
{
    // add zero in front of numbers < 10
    if (i < 10) {
        i = `0${i}`;

        return i;
    }
}

let countUpTimes = [];
export let countUpIds = [];

export function initCountUps()
{
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getYear() + 1900;
    const hour = today.getHours();
    const minutes = today.getMinutes();
    const seconds = today.getSeconds();

    countUpIds = [];
    countUpTimes = [];

    $('.countUp').each(function countUpEach() {
        const timeParts = $(this).html().split(':');
        countUpIds.push($(this).attr('id'));
        countUpTimes.push(
            mktime(year,
                month,
                day,
                hour - timeParts[0],
                minutes - timeParts[1],
                seconds - timeParts[2]),
        );
    });
    setTimeout(countUp, 500);
}
window.initCountUps = initCountUps;

function mktime(year, month, day, hour, minutes, seconds)
{
    return new Date(year, month - 1, day, hour, minutes, seconds);
}

function countUp()
{
    const now = new Date();
    for (let i = 0; i < countUpIds.length; i++) {
        const seconds = Math.floor((now.getTime() - countUpTimes[i].getTime()) / 1000);
        const time = secondsToHHMMSS(seconds);
        $(`#${countUpIds[i]}`).html(time);
    }
    setTimeout(countUp, 500);
}

function secondsToHHMMSS(sec_num)
{
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10) {
        hours = `0${hours}`;
    }

    if (minutes < 10) {
        minutes = `0${minutes}`;
    }

    if (seconds < 10) {
        seconds = `0${seconds}`;
    }

    return `${hours}:${minutes}:${seconds}`;
}

function timestampToHHMMSS(stamp)
{
    const date = new Date(stamp * 1000);
    // Hours part from the timestamp
    const hours = date.getHours();
    // Minutes part from the timestamp
    const minutes = `0${date.getMinutes()}`;
    // Seconds part from the timestamp
    const seconds = `0${date.getSeconds()}`;
    // Will display time in 10:30:23 format
    const formattedTime = `${hours}:${minutes.substr(-2)}:${seconds.substr(-2)}`;

    return formattedTime;
}
window.timestampToHHMMSS = timestampToHHMMSS;

function ucfirst(string)
{
    return string[0].toUpperCase() + string.slice(1);
}

function normalizeEntitiesAutocompleteSource(source, parentName)
{
    return source.map((item) => ({
        id: String(item.id ?? ''),
        label: String(item.name ?? ''),
        value: String(item.name ?? ''),
        parent: String(item.parent ?? parentName ?? ''),
    })).filter((item) => item.id !== '' && item.label !== '' && item.parent !== '');
}

function getEntityHiddenElement($input, parentName)
{
    const hiddenName = String(parentName ?? '');
    if (hiddenName === '') {
        return null;
    }

    const matchesHidden = function matchesHiddenName() {
        return this.id === hiddenName || this.name === hiddenName;
    };

    const $fieldHidden = $input
        .closest('[data-nais-field], .form-group')
        .find('input[type="hidden"]')
        .filter(matchesHidden)
        .first();
    if ($fieldHidden.length) {
        return $fieldHidden[0];
    }

    const form = $input[0]?.form ?? null;
    const $formHidden = form
        ? $(form).find('input[type="hidden"]').filter(matchesHidden).first()
        : $();
    if ($formHidden.length) {
        return $formHidden[0];
    }

    const $documentHidden = $('input[type="hidden"]').filter(matchesHidden).first();
    return $documentHidden.length ? $documentHidden[0] : null;
}

function setEntityHiddenInputValue($input, parentName, value)
{
    const hidden = getEntityHiddenElement($input, parentName);
    if (!hidden) {
        return null;
    }

    $(hidden).val(String(value)).attr('value', String(value));

    return hidden;
}

function setEntityPickerValue($input, item, options = {})
{
    const parentName = $input.attr('parent') || item.parent;
    const $group = $input.closest('div.input-group');
    const form = $input[0]?.form ?? null;
    const emit = options.emit !== false;

    $input.data('naisEntityPickerSyncing', true);

    try {
        const hidden = setEntityHiddenInputValue($input, parentName, item.id);

        $input
            .val(item.label)
            .data('naisSelectedEntityLabel', item.label);

        if (emit && hidden) {
            $(hidden).trigger('change');
        }
        if (emit && window.Nette?.validateControl) {
            window.Nette.validateControl($input[0]);
        }
        if (emit && window.Nette?.toggleForm && form) {
            window.Nette.toggleForm(form, $input[0]);
        }
        if (emit && form) {
            $(form).trigger('checkform.areYouSure');
        }
    } finally {
        $input.removeData('naisEntityPickerSyncing');
    }

    $group.find('.nais-entities-clear, .input-group-text.danger').removeClass('disn');
}

function getEntitiesAutocompleteSource($input)
{
    const raw = $input.attr('data-nais-entities-source');
    if (!raw) {
        return [];
    }

    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}

function setEntitiesAutocompleteSource($input, source)
{
    $input.attr('data-nais-entities-source', JSON.stringify(source));

    if (typeof $input.autocomplete === 'function' && $input.data('ui-autocomplete')) {
        $input.autocomplete(
            'option',
            'source',
            normalizeEntitiesAutocompleteSource(source, $input.attr('parent')),
        );
    }
}

function upsertEntityPickerSourceItem($input, id, name, parentName)
{
    const source = getEntitiesAutocompleteSource($input);
    const item = {
        id: String(id),
        name: String(name),
        parent: String(parentName || $input.attr('parent') || ''),
    };

    if (item.id === '' || item.name === '' || item.parent === '') {
        return;
    }

    const existingIndex = source.findIndex((sourceItem) => String(sourceItem.id ?? '') === item.id);
    if (existingIndex >= 0) {
        source[existingIndex] = { ...source[existingIndex], ...item };
    } else {
        source.push(item);
    }

    setEntitiesAutocompleteSource($input, source);
}

function clearEntityPickerValue($input, options = {})
{
    const parentName = $input.attr('parent');
    const hidden = getEntityHiddenElement($input, parentName);
    const form = $input[0]?.form ?? null;
    const emit = options.emit === true;

    if (hidden) {
        $(hidden).val('').removeAttr('value');
    }

    $input.val('');
    $input
        .removeData('naisSelectedEntityLabel')
        .closest('div.input-group')
        .find('.nais-entities-clear, .input-group-text.danger')
        .addClass('disn');

    if (emit && hidden) {
        $(hidden).trigger('change');
    }
    if (emit) {
        $input.trigger('change');
        if (window.Nette?.validateControl) {
            window.Nette.validateControl($input[0]);
        }
        if (form) {
            $(form).trigger('checkform.areYouSure');
        }
    }
}

function bindEntitiesClearButtons()
{
    $(document)
        .off('click.naisEntitiesClear', '.nais-entities-clear')
        .on('click.naisEntitiesClear', '.nais-entities-clear', function onEntitiesClear() {
            const $button = $(this);
            const inputName = $button.attr('data-name') || '';
            const hiddenName = $button.attr('data-hidden-name') || '';
            const $group = $button.closest('div.input-group');
            const $input = inputName !== ''
                ? $group.find(`input[name="${inputName}"]`).first()
                : $group.find('input:text.entitiesForm').first();

            if ($input.length) {
                clearEntityPickerValue($input, { emit: true });
            } else if (hiddenName !== '') {
                const hidden = document.getElementById(hiddenName)
                    || document.querySelector(`input[type="hidden"][name="${hiddenName}"]`);

                if (hidden) {
                    hidden.value = '';
                    hidden.removeAttribute('value');
                }

                $button.addClass('disn');
            }
        });
}

/**
 * Drop the bound entity id while keeping whatever the user typed (search-in-progress).
 */
function invalidateEntityPickerSelection($input)
{
    const parentName = $input.attr('parent');
    const hidden = getEntityHiddenElement($input, parentName);

    if (hidden) {
        $(hidden).val('').removeAttr('value');
    }

    $input.removeData('naisSelectedEntityLabel');
    $input
        .closest('div.input-group')
        .find('.nais-entities-clear, .input-group-text.danger')
        .addClass('disn');
}

/**
 * Keep text ↔ hidden id in sync.
 * @param {{allowPartial?: boolean}} options allowPartial=true while typing so search text is not wiped
 */
function syncEntityPickerAfterManualInput($input, items, options = {})
{
    if ($input.data('naisEntityPickerSyncing')) {
        return;
    }

    const currentValue = String($input.val() ?? '');
    const allowPartial = options.allowPartial === true;

    if (currentValue === '') {
        clearEntityPickerValue($input);
        return;
    }

    const selectedLabel = $input.data('naisSelectedEntityLabel');
    const matchedItem = items.find((item) => item.label === currentValue);
    if (selectedLabel && selectedLabel === currentValue) {
        if (matchedItem) {
            setEntityHiddenInputValue($input, matchedItem.parent, matchedItem.id);
        }
        return;
    }

    if (matchedItem) {
        setEntityPickerValue($input, matchedItem);
        return;
    }

    // Partial search term: keep typed text, clear stale selection. Blur wipes free text.
    if (allowPartial) {
        invalidateEntityPickerSelection($input);
        return;
    }

    clearEntityPickerValue($input);
}

function getEntitiesAutocompleteAppendTo($input)
{
    const $modalBody = $input.closest('.modal-body');
    if ($modalBody.length) {
        return $modalBody;
    }

    const $modal = $input.closest('.modal');

    return $modal.length ? $modal : $(document.body);
}

let activeEntitiesAutocompleteScrollLock = null;
const ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS = '.naisEntitiesAutocompleteScrollLock';

function getEntitiesAutocompleteScrollContainer($input)
{
    const $modalBody = $input.closest('.modal-body');
    if ($modalBody.length) {
        return $modalBody;
    }

    const $scrollParent = $input.parents().filter(function filterScrollableParent() {
        const styles = window.getComputedStyle(this);
        const overflow = `${styles.overflow}${styles.overflowY}`;

        return /(auto|scroll)/.test(overflow) && this.scrollHeight > this.clientHeight;
    }).first();

    return $scrollParent.length ? $scrollParent : $(window);
}

function restoreEntitiesAutocompleteScrollPosition()
{
    if (!activeEntitiesAutocompleteScrollLock) {
        return;
    }

    const { $container, scrollTop } = activeEntitiesAutocompleteScrollLock;
    if ($container[0] === window) {
        window.scrollTo(window.scrollX, scrollTop);
        return;
    }

    $container.scrollTop(scrollTop);
}

function unlockEntitiesAutocompleteScroll()
{
    if (!activeEntitiesAutocompleteScrollLock) {
        return;
    }

    activeEntitiesAutocompleteScrollLock.$eventTarget.off(ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS);
    activeEntitiesAutocompleteScrollLock.$widget.off(ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS);
    activeEntitiesAutocompleteScrollLock = null;
}

function lockEntitiesAutocompleteScroll($input)
{
    unlockEntitiesAutocompleteScroll();

    const $container = getEntitiesAutocompleteScrollContainer($input);
    const $eventTarget = $container[0] === window ? $(window) : $container;
    const $widget = $input.autocomplete('widget');
    const scrollTop = $container[0] === window ? window.scrollY : $container.scrollTop();

    activeEntitiesAutocompleteScrollLock = {
        $container,
        $eventTarget,
        $widget,
        scrollTop,
    };

    $widget
        .off(ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS)
        .on(`wheel${ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS} touchmove${ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS}`, (event) => {
            event.stopPropagation();
        });

    $eventTarget
        .off(ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS)
        .on(`wheel${ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS} touchmove${ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS}`, (event) => {
            if ($(event.target).closest($widget).length) {
                return;
            }

            event.preventDefault();
            restoreEntitiesAutocompleteScrollPosition();
        })
        .on(`scroll${ENTITIES_AUTOCOMPLETE_SCROLL_LOCK_NS}`, () => {
            restoreEntitiesAutocompleteScrollPosition();
        });
}

function bindEntitiesAutocompleteDropdown($input)
{
    $input
        .off('autocompleteopen.naisEntitiesDropdown')
        .on('autocompleteopen.naisEntitiesDropdown', function onEntitiesAutocompleteOpen() {
            const $currentInput = $(this);
            const $widget = $currentInput.autocomplete('widget');

            $widget.outerWidth($currentInput.outerWidth());
            lockEntitiesAutocompleteScroll($currentInput);
        });
}

export function initEntitiesAutocomplete()
{
    bindEntitiesClearButtons();
    bindEntitiesPickerButtons();
    bindEntityPickerChoiceButtons();

    $('input:text.entitiesForm').each(function entitiesFormEach() {
        const $input = $(this);

        if (typeof $input.autocomplete !== 'function') {
            return;
        }

        const getItems = () => normalizeEntitiesAutocompleteSource(
            getEntitiesAutocompleteSource($input),
            $input.attr('parent'),
        );
        const items = getItems();

        // Re-init after AJAX / soft navigation
        if ($input.data('ui-autocomplete')) {
            $input.autocomplete('destroy');
        }

        $input.autocomplete({
            source: items,
            appendTo: getEntitiesAutocompleteAppendTo($input),
            minLength: 0,
            delay: 0,
            autoFocus: false,
            classes: {
                'ui-autocomplete': 'nais-entities-autocomplete',
            },
            select(event, ui) {
                event.preventDefault();
                setEntityPickerValue($input, ui.item);
                return false;
            },
            focus(event) {
                event.preventDefault();
                return false;
            },
        });
        bindEntitiesAutocompleteDropdown($input);

        // Open on click, not on focus. Opening during the focus phase can turn the
        // original click into an accidental menu selection in jQuery UI.
        $input
            .off('click.naisEntitiesAutocomplete focus.naisEntitiesAutocomplete keydown.naisEntitiesAutocomplete')
            .on('click.naisEntitiesAutocomplete', function onEntitiesOpen() {
                $(this).autocomplete('search', '');
            })
            .on('keydown.naisEntitiesAutocomplete', function onEntitiesKeyboardOpen(event) {
                if (event.key === 'ArrowDown' || event.keyCode === 40) {
                    $(this).autocomplete('search', '');
                }
            });

        $input
            .off('input.naisEntitiesAutocomplete change.naisEntitiesAutocomplete blur.naisEntitiesAutocomplete')
            .on('input.naisEntitiesAutocomplete', function onEntitiesManualInput() {
                syncEntityPickerAfterManualInput($(this), getItems(), { allowPartial: true });
            })
            .on('change.naisEntitiesAutocomplete blur.naisEntitiesAutocomplete', function onEntitiesValueChanged() {
                syncEntityPickerAfterManualInput($(this), getItems());
            });

        $input
            .off('autocompleteselect.naisEntitiesAutocomplete autocompleteclose.naisEntitiesAutocomplete')
            .on('autocompleteclose.naisEntitiesAutocomplete', function onEntitiesClose() {
                unlockEntitiesAutocompleteScroll();
                // Keep partial search text while focused; blur/change clears free text.
                syncEntityPickerAfterManualInput($(this), getItems(), { allowPartial: true });
            });

        const initialValue = String($input.val() ?? '');
        if (initialValue !== '') {
            const initialItem = items.find((item) => item.label === initialValue);
            if (initialItem) {
                setEntityPickerValue($input, initialItem, { emit: false });
            } else {
                $input
                    .data('naisSelectedEntityLabel', initialValue)
                    .closest('div.input-group')
                    .find('.nais-entities-clear, .input-group-text.danger')
                    .removeClass('disn');
            }
        }
    });
}
window.initEntitiesAutocomplete = initEntitiesAutocomplete;

export function initEntitiesTables()
{
    $('table.entitiesListTable:not(.dataTable)').each(function entitiesListEach() {
        const $table = $(this);
        const listName = $table.data('list-name') || $table.attr('id');
        const allowed = $(`#${listName}Allowed`).val();
        const dictionary = getNaisDictionary();
        const isModern = $table.closest('[data-nais-entities]').length > 0;

        localStorage.setItem(listName, '{}');

        if (allowed === 'true') {
            $table.html(`<thead><tr><th>${dictionary.id}</th><th>${dictionary.name}</th></tr></thead><tbody></tbody>`);
        }

        if (!isModern) {
            $table.prev().prev()
                .replaceWith(`<label class='control-label col-md-3 col-sm-3 col-12'>${$table.attr('label')}</label>`);
            $table.prev().attr({ id: 'dependency-span', class: 'wrap' });
            $table.prev().find('input').attr({ class: allowed === 'true' ? 'btn btn-info' : 'btn' });
            $table.parents('div.form-group')
                .find('div.wrap, table.wrap').wrapAll("<div class='col-md-6 col-sm-6 col-12' />");
        }

        if (allowed === 'true') {
            $table.DataTable({
                language: dataTablesLangs[$('html').attr('lang')],
                order: [[0, 'asc']],
                retrieve: true,
                pageLength: 5,
                paging: false,
                lengthChange: false,
                searching: false,
                ordering: false,
                info: false,
                autoWidth: false,
            });
        }

        const object = JSON.parse($(`#${listName}JSON`).val() || '{}');
        window.activeMultipleSelect = listName;
        localStorage.setItem(listName, JSON.stringify({}));

        for (const property in object) {
            if (Object.prototype.hasOwnProperty.call(object, property)) {
                saveSelectedEntity(property, object[property]);
            }
        }
    });
}
window.initEntitiesTables = initEntitiesTables;

// Enable dropdowns in quick filters
function dropdown()
{
    $('.dropdown-toggle button').attr('aria-expanded', 'true');
    $('.dropdown button').toggleClass('open');
}
window.dropdown = dropdown;

// filter
function showFilter(element)
{
    let formElement = '';
    if (element !== undefined) {
        const form = element.closest('form');
        const id = $(form).attr('id');
        formElement = 'form#' + id + ' ';
    }
    if ($(formElement + '.filter-body').css('display') === 'none') {
        $(formElement + '.filter-body').fadeIn(() => {
            $(formElement + '.floatedTable').floatThead('reflow');
            if (typeof window.init_datagrid_filter_selects === 'function') {
                const filterPanel = document.querySelector(formElement + '.filter-body');
                window.init_datagrid_filter_selects(filterPanel ?? document);
            }
            if (typeof window.initCalendars === 'function') {
                window.initCalendars();
            }
            if (typeof window.initRangeLinks === 'function') {
                const filterPanel = document.querySelector(formElement + '.filter-body');
                window.initRangeLinks(filterPanel ?? document);
            }
        });
        window.location.hash = '#filterOpen';
        if ($(formElement + '.ordering-body').css('display') !== 'none') {
            $(formElement + '.ordering-body').fadeOut(() => {
                $(formElement + '.floatedTable').floatThead('reflow');
            });
        }
    } else {
        $(formElement + '.filter-body').fadeOut(() => {
            $(formElement + ' .floatedTable').floatThead('reflow');
        });
        window.location.hash = '#filterClose';
    }
    return false;
}
window.showFilter = showFilter;

// ordering
function showOrdering()
{
    if ($('.ordering-body').css('display') === 'none') {
        $('.ordering-body').fadeIn(() => {
            $('.floatedTable').floatThead('reflow');
            if (typeof window.initDatagridOrdering === 'function') {
                window.initDatagridOrdering();
            }
        });
        if ($('.filter-body').css('display') !== 'none') {
            $('.filter-body').fadeOut(() => {
                $('.floatedTable').floatThead('reflow');
            });
        }
    } else {
        $('.ordering-body').fadeOut(() => {
            $('.floatedTable').floatThead('reflow');
        });
    }
}
window.showOrdering = showOrdering;

function reloadList(element, listType)
{
    selected = $(`#${element}`).find(':selected').val();
    $.nette.ajax({
        type: 'get',
        url: '?do=reloadSubtype',
        data: {
            listName: listType,
        },
        success(el) {
            $(`#${element}`).empty();
            for (const key in el) {
                if (typeof (el[key] === 'string')) {
                    if (key === selected) {
                        $(`#${element}`).append(`<option value="${key}" selected>${el[key]}</option>`);
                    } else {
                        $(`#${element}`).append(`<option value="${key}">${el[key]}</option>`);
                    }
                }
            }
        },
    });
}
window.reloadList = reloadList;

/**
 * @return { number }
 */
function GetIEVersion()
{
    const sAgent = window.navigator.userAgent;
    const Idx = sAgent.indexOf('MSIE');

    // If IE, return version number.
    if (Idx > 0) {
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)));
    }

    // If IE 11 then look for Updated user agent string.
    if (navigator.userAgent.match(/Trident\/7\./)) {
        return 11;
    }

    // Edge detection
    if (navigator.userAgent.match(/Edge\//)) {
        return 1000;
    }
    return 0; // It is not IE
}
window.GetIEVersion = GetIEVersion;

function slug(str)
{
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    const from = 'ýěščřžáíéóůúãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;';
    const to = 'yescrzaieouuaaaaaeeeeeiiiiooooouuuunc------';
    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}
window.slug = slug;

(function smartresizeCallback($, sr) {
    // debouncing function from John Hann
    // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
    const debounce = function debounceFunction(func, threshold, execAsap) {
        let timeout;

        return function debounced()
        {
            const obj = this; const
                args = arguments;
            function delayed()
            {
                if (!execAsap) {
                    func.apply(obj, args);
                }
                timeout = null;
            }

            if (timeout) {
                clearTimeout(timeout);
            } else if (execAsap) {
                func.apply(obj, args);
            }

            timeout = setTimeout(delayed, threshold || 100);
        };
    };

    // smartresize
    jQuery.fn[sr] = function bindResize(fn) {
        return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
}(jQuery, 'smartresize'));

// Correct tab order within forms (added for Safari)
const Tab = {};
Tab.i = 1;
Tab.items = 0;

function fixTabulation()
{
    /* This can be used to auto-assign tab-indexes, or
    #  commented out if it manual tab-indexes have
    #  already been assigned.
    */
    $('input, select, textarea').each(function tabulationFixEach() {
        $(this).attr('tabindex', Tab.i);
        Tab.i++;
        Tab.items++;
    });

    Tab.i = 0;

    /* We need to listen for any forward or backward Tab
    #  key event tell the page where to focus next.
    */
    $(document).on({
        keydown(e) {
            if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
                if (e.keyCode === 9 && !e.shiftKey) { // Tab key pressed
                    e.preventDefault();
                    Tab.i !== Tab.items ? Tab.i++ : Tab.i = 1;
                    $(`input[tabindex="${Tab.i}"], select[tabindex="${Tab.i}"], textarea[tabindex="${Tab.i}"]`)
                        .not('input[type="hidden"]').focus();
                }
                if (e.shiftKey && e.keyCode === 9) { // Tab key pressed
                    e.preventDefault();
                    Tab.i !== 1 ? Tab.i-- : Tab.i = Tab.items;
                    $(`input[tabindex="${Tab.i}"], select[tabindex="${Tab.i}"], textarea[tabindex="${Tab.i}"]`)
                        .not('input[type="hidden"]').focus();
                }
            }
        },
    });

    /* We need to update Tab.i if someone clicks into
    #  a different part of the form.  This allows us
    #  to keep tabbing from the newly clicked input
    */
    $('input[tabindex], select[tabindex], textarea[tabindex]').not('input[type="hidden"]')
        .focus(function tabIndexEach(e) {
            Tab.i = $(this).attr('tabindex');
        });
}
window.fixTabulation = fixTabulation;

function showImageMap(url) {
    showHelp(url + '&showEntity=1');
};
window.showImageMap = showImageMap;
